module.exports = require("node:string_decoder");